module.exports = __webpack_public_path__ + "img/delivery-truck-sm.5a9d56b0.png";